import React from 'react'

const RequestedFriend = () => {
    return (
        <div>
            
        </div>
    )
}

export default RequestedFriend
